import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollFade = () => {
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    // Defer observation so the page entrance animation starts first
    const timer = setTimeout(() => {
      document.querySelectorAll('.scroll-fade').forEach(el => observer.observe(el));
    }, 50);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [location.pathname]);
};

export default useScrollFade;
